import { render, staticRenderFns } from "./IndexCarousel.vue?vue&type=template&id=300d1115&scoped=true&"
import script from "./IndexCarousel.vue?vue&type=script&lang=js&"
export * from "./IndexCarousel.vue?vue&type=script&lang=js&"
import style0 from "./IndexCarousel.vue?vue&type=style&index=0&id=300d1115&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300d1115",
  null
  
)

export default component.exports